module.exports = __webpack_public_path__ + "static/media/settings.9600fec6.svg";